import UISelect from 'UIComponents/input/UISelect';
import getIn from 'transmute/getIn';
import EditorRelatedConditionsHeadingAssociationSelectValueComponent from './EditorRelatedConditionsHeadingAssociationSelectValueComponent';
import { useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorCrmObjectAssociationSelect = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const {
    associationValue,
    associationOptions,
    onAssociationChange
  } = useFlexibleAssociations(logicGroup, conditionPath);
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    _jsx(UISelect, {
      menuWidth: "auto",
      onChange: evt => onAssociationChange(evt.target.value),
      options: associationOptions,
      value: associationValue || getIn([0, 'value'], associationOptions),
      valueComponent: EditorRelatedConditionsHeadingAssociationSelectValueComponent
    })
  );
};
export default EditorCrmObjectAssociationSelect;